export const getProjectAbsoluteUrl = (projectId) =>
  `${window.location.origin}/project/${projectId}`;

export const getProjectRelativeUrl = (projectId) => `/project/${projectId}`;
